export const HONOR_CODE = 'honor_code' as const;
export const WAITING_ROOM = 'waiting_room' as const;
export const DOOR_NOTES = 'door_notes' as const;
export const EMR = 'emr' as const;
export const START_RECORDING = 'start_recording' as const;
export const STUDENT_START_RECORDING = 'student_start_recording' as const;
export const ENCOUNTER = 'encounter' as const;
export const POST_ENCOUNTER = 'post_encounter' as const;

export type ExamFlowPhase = (typeof ExamFlowPhases)[keyof typeof ExamFlowPhases];

const ExamFlowPhases = {
    HONOR_CODE,
    WAITING_ROOM,
    DOOR_NOTES,
    EMR,
    START_RECORDING,
    STUDENT_START_RECORDING,
    ENCOUNTER,
    POST_ENCOUNTER,
} as const;

export default ExamFlowPhases;
